"use client";

import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import type { MenuItem } from "@/lib/shopify/types";
import { cn } from "@/lib/format";
import { ChevronIcon } from "@/components/ui/icons";

export function OccasionsMenu({ occasions }: { occasions: MenuItem[] }) {
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onPointer = (event: PointerEvent) => {
      if (!root.current?.contains(event.target as Node)) setOpen(false);
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("pointerdown", onPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div ref={root} className="relative">
      <button
        type="button"
        className="flex items-center gap-1.5 py-2 nav-link"
        aria-expanded={open}
        aria-controls="occasions-menu"
        onClick={() => setOpen((value) => !value)}
      >
        Occasions
        <ChevronIcon className={cn("size-3.5 transition-transform", open && "rotate-180")} />
      </button>
      <div
        id="occasions-menu"
        hidden={!open}
        className="absolute left-0 top-full mt-3 w-64 animate-[rise_0.35s_var(--ease-soft)] rounded-[4px] border border-gold/40 bg-cocoa p-2 text-paper shadow-[0_18px_40px_-18px_rgb(51_36_27/0.35)]"
      >
        <ul>
          {occasions.map((item) => (
            <li key={item.path}>
              <Link
                href={item.path}
                className="block rounded-[3px] px-3 py-2 font-display text-lg hover:bg-paper/10"
                onClick={() => setOpen(false)}
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
